import FastMarquee from "react-fast-marquee";

const WORDS = [
  "Finance",
  "Sales",
  "Marketing",
  "HR",
  "Operations",
  "Customer Support",
  "Analytics",
  "Administration",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y border-white/5 bg-[#070707] py-12"
    >
      <FastMarquee speed={32} gradient={false} pauseOnHover>
        {WORDS.map((w, i) => (
          <span key={w} className="flex items-center">
            <span
              className={`mx-10 font-display text-5xl font-light tracking-tight md:text-7xl ${
                i % 2 === 0 ? "text-[#F5F5F5]/75" : "stroke-gold"
              }`}
            >
              {w}
            </span>
            <span className="font-display text-3xl text-gold/50 md:text-4xl">
              Λ
            </span>
          </span>
        ))}
      </FastMarquee>
      <p className="mt-8 text-center font-mono text-[11px] uppercase tracking-[0.4em] text-gold/70">
        All working together — Powered by Alkyrvis
      </p>
    </section>
  );
}
